<template>
  <div>
    <el-dialog
        title="新增商品"
        :visible.sync="createDialog"
        width="980px" >
      <div style="margin-left: 30px" v-loading="createLoading">
        <el-form label-position="top" :model="productItem" :rules="rules" ref="formRef" label-width="110px">
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="100px" label="商品名称" prop="name">
                <el-input v-model="productItem.name" style="width: 210px" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="100px" label="库存数量" prop="amount">
                <el-input-number v-model="productItem.amount" :min="1" :max="10000"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="100px" label="兑换积分" prop="score">
                <el-input-number v-model="productItem.score" :min="1" :max="10000"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="100px" label="商品图片" prop="image">
                <el-upload action=" " class="upload" :http-request="updateImage"
                           accept="image/jpg,image/jpeg,image/png"
                    list-type="picture-card" :limit="1">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label-width="100px" label="商品说明">
                <el-input style="width: 80%;"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入"
                    v-model="productItem.notes">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialog = false">取 消</el-button>
        <el-button type="danger" :disabled="createLoading" @click="created">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { upLoadImage } from '/src/api/utils/uploadFile';
import {insertProduct} from "../../../../../../api/contacts/hr/product";
export default {
  name: "CreatedProduct",
  data() {
    return {
      createDialog:false,
      createLoading:false,
      productItem:{
        name:"",
        amount:1,
        score:1,
        image:null,
        notes:""
      },
      rules: {
        name: [{ required: true, message: "请输入商品名称！", trigger: "blur" }],
        score: [{ required: true, message: "请输入扣减积分！", trigger: "blur" }],
        amount: [{ required: true, message: "请输入商品库存！", trigger: "blur" }],
        image: [{ required: true, message: "请选择商品图片！", trigger: "blur" }],
        startAndEndDate: [{ required: true, message: "请选择有效期！", trigger: "blur" }],
      }
    }
  },
  methods:{
    openDialog() {
      this.createDialog = true;
    },
    updateImage(val){
      const data = new FormData()
      data.append('multipartFile',val.file)
      upLoadImage(data).then(res => {
        if (res.data) {
          this.productItem.image = res.data;
        }
      });
    },
    created(){
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          insertProduct(this.productItem).then(val=>{
            this.createLoading = false;
            if (val.status == 200){
              this.$emit('refresh');
              this.createDialog = false;
              this.$notify.success({title: '提示', message: '新增成功！', offset: 40});
              Object.keys(this.ruleItem).forEach((key) => (this.ruleItem[key] = null));
            }else {
              this.$notify.error({title: '新增失败！', message: val.data, offset: 40});
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .el-upload--picture-card {
  width: 90px;
  height: 90px;
}

/deep/ .el-upload {
  width: 90px;
  height: 90px;
  line-height: 90px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 90px;
  height: 90px;
  line-height: 90px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 90px;
  height: 90px;
  line-height: 90px;
}
/* 隐藏上传组件的添加按钮 */
.upload .el-upload--picture-card {
  display: none !important;
}
</style>